import { render, staticRenderFns } from "./dialogArchivingStimulus.vue?vue&type=template&id=79d63b74"
import script from "./dialogArchivingStimulus.vue?vue&type=script&lang=js"
export * from "./dialogArchivingStimulus.vue?vue&type=script&lang=js"
import style0 from "./dialogArchivingStimulus.vue?vue&type=style&index=0&id=79d63b74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports